import i18next from 'i18next';
import React from 'react';

import { MenuItem } from '@material-ui/core';
import TextInput from 'components/TextInput/TextInput';
import { useTranslation } from 'react-i18next';
import useStyles from './RecordDialogLayoutStyles';

export const CreateRecordTypeChange = ({
  handleChange,
  selectedType,
  disabled,
  recordType,
}) => {
  const recordTypeList = {
    work: i18next.t('common:record.type.work'),
    projectWork: i18next.t('common:record.type.projectWork'),
    break: i18next.t('common:record.type.break'),
    coffeeBreak: i18next.t('common:record.type.coffee_break'),
    mealBreak: i18next.t('common:record.type.meal_break'),
    shift: i18next.t('common:record.type.shift'),
    absence: i18next.t('common:record.type.absence'),
    benefit: i18next.t('common:record.type.benefit'),
    ride: i18next.t('common:record.type.ride'),
    item: i18next.t('common:record.type.item'),
    negative: i18next.t('common:record.type.negative'),
  };

  const allTypeOptions = [
    { value: 'WORK', label: recordTypeList.work },
    { value: 'PROJECTWORK', label: recordTypeList.projectWork },
    { value: 'BREAK', label: recordTypeList.break },
    { value: 'BREAK_COFFEE', label: recordTypeList.coffeeBreak },
    { value: 'BREAK_MEAL', label: recordTypeList.mealBreak },
    { value: 'SHIFT', label: recordTypeList.shift },
    { value: 'ABSENCE', label: recordTypeList.absence },
    { value: 'BENEFIT', label: recordTypeList.benefit },
    { value: 'RIDE', label: recordTypeList.ride },
    { value: 'ITEM', label: recordTypeList.item },
    { value: 'NEGATIVE', label: recordTypeList.negative },
  ];

  const selectableTypeOptions = ['WORK', 'PROJECTWORK'];

  let typeOptions = [];

  if (recordType === 'BREAK') {
    typeOptions = allTypeOptions.filter((typeOption) => {
      return (
        typeOption.value.includes('BREAK') || typeOption.value === selectedType
      );
    });
  } else if (recordType === 'ALLOWANCE') {
    typeOptions = allTypeOptions.filter(
      (typeOption) => typeOption.value === 'RIDE'
    );
  } else {
    typeOptions = allTypeOptions.filter((item) =>
      selectableTypeOptions.includes(item.value)
    );
  }

  const { t } = useTranslation('common');
  const classes = useStyles();

  const typeSelected = allTypeOptions.find(
    (type) => type.value === selectedType
  );

  return (
    <div>
      <TextInput
        displayEmpty
        fullWidth
        id="edit-record-type-select"
        label={t('calendar.type')}
        MenuProps={{
          PaperProps: {
            className: classes.menuPaper,
          },
        }}
        onChange={(e) => handleChange(e.target.value)}
        select
        shrink
        value={typeSelected.value}
        disabled={disabled}
        error={!typeSelected.value}
      >
        {typeOptions.map((item) => (
          <MenuItem
            className={classes.menuItem}
            key={item.value}
            value={item.value}
          >
            {item.label}
          </MenuItem>
        ))}
      </TextInput>
    </div>
  );
};
